import { useTranslation } from "react-i18next";
import ConfirmationPopup from "../../common/ConfirmationPopup/ConfirmationPopup.tsx";
import { useAppStore } from "../../../hooks/useStores.tsx";

interface RecentLoginPopupProps {
	open: boolean;
	onClose?: () => void;
	loading?: boolean;
	disabled?: boolean;
}

const RecentLoginPopup = ({ open, onClose, loading = false, disabled = false }: RecentLoginPopupProps) => {
	const { t } = useTranslation("translation", { keyPrefix: "recentLoginPopup" });
	const { authStore } = useAppStore();

	const handleLogout = () => {
		authStore.logout();
		if (onClose) {
			onClose();
		}
	};

	return (
		<ConfirmationPopup
			onClose={onClose || (() => {})}
			title={t("title")}
			description={t("description")}
			confirmButtonText={t("confirmButton")}
			open={open}
			onClick={handleLogout}
			hideCancel={false}
			loading={loading}
			disabled={disabled}
		/>
	);
};

export default RecentLoginPopup; 